import { useCallback, useEffect } from "react";
import useUserStore from "@store/useUserStore";
import useTourLikeStore from "@store/useTourLikeStore";
import { useSnackbar } from "contexts/SnackbarContext";

/**
 * 투어 찜 상태 훅.
 * - 로그인 사용자의 찜 ID 를 한 번만 불러와 화면 간 공유한다.
 * - toggleLike 는 비로그인 시 false 를 반환하므로 호출부에서 로그인 유도 UI 를 띄운다.
 */
const useTourLikes = () => {
    const userInfo = useUserStore((state) => state.userInfo);
    const userKey = userInfo?.user_id ?? userInfo?.id ?? null;
    const likedIds = useTourLikeStore((state) => state.likedIds);
    const loadLikedIds = useTourLikeStore((state) => state.loadLikedIds);
    const toggle = useTourLikeStore((state) => state.toggleLike);
    const reset = useTourLikeStore((state) => state.reset);
    const { showError, showSuccess } = useSnackbar();

    useEffect(() => {
        if (userKey) loadLikedIds(userKey);
        else reset();
    }, [userKey, loadLikedIds, reset]);

    const isLiked = useCallback((id) => likedIds.has(Number(id)), [likedIds]);

    const toggleLike = useCallback(
        async (id) => {
            if (!userKey) return false;
            const willLike = !likedIds.has(Number(id));
            const ok = await toggle(id);
            if (!ok) showError("찜 처리에 실패했습니다. 잠시 후 다시 시도해주세요.");
            else if (willLike) showSuccess("찜한 투어에 추가했어요.");
            return true;
        },
        [userKey, likedIds, toggle, showError, showSuccess]
    );

    return { isLoggedIn: Boolean(userKey), isLiked, toggleLike };
};

export default useTourLikes;
